import { useTranslation } from 'react-i18next';

import { IconType, Icons } from '../../../constants/icons';

type ResetPasswordSuccessGroupProps = {
  email: string;
};

export const ResetPasswordSuccessGroup = (
  props: ResetPasswordSuccessGroupProps,
) => {
  const { email } = props;
  const { t } = useTranslation();
  return (
    <div className="email-verification">
      <div className="centered-container">
        <section>
          <div className="text-content">
            <img className="tick-icon" src={Icons[IconType.Tick]} />

            <p className="text-3xl font-bold">
              {t('You have reset your password.')}
            </p>
            <p>{t('Please try to login with your new password.')}</p>
            <div className="flex flex-row gap-1 justify-center items-center">
              <img className="size-icon-m" src={Icons[IconType.Email]} />
              <p style={{ color: '#000' }}>{email}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
